import FieldEditor from "editor/FieldEditor";

class AdminCategoriesEditor extends FieldEditor {

    create() {
        this.editors = [];

        this.$element.addClass("admin-categories-editor");

        this.$add_item = (
            eotwJSXFactory('div', {class: "admin-categories-editor__category"}, [
                eotwJSXFactory('input', {type: "text", class: "admin-form__input js-add-item"}),
                eotwJSXFactory('button', {class: "admin-btn admin-btn--icon", disabled: true}, [
                    eotwJSXFactory('span', {class: "admin-btn__icon"}).html("<svg><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='" + window.CONFIG.adminBuildUrl + "base/icons.svg#delete'></use></svg>")
                ])
            ])
        );
        const me = this;

        this.$element.on("change keypress", () => this.emit("change")).on("focus", ".js-add-item", function () {
            let $editor = me.generateCategoryField({name: $(this).val()});
            $editor.find("input").focus();
            return false;
        });

        this.updateAddItem();
    }

    updateAddItem() {
        this.$element.append(this.$add_item);
        this.$add_item.find("input").val("");
    }

    destroy() {
        super.destroy();
        this.editors.forEach(($el) => $el.remove());
    }

    getValue() {
        return this.editors.map(($el) => (
            {
                id: $el.attr("data-id"),
                name: $el.find("input").val(),
            }
        )).filter((category) => category.name.trim() !== "");
    }

    setValue(value) {
        this.editors.forEach(($el) => $el.remove());
        this.editors = [];

        if (value instanceof Array) {
            value.forEach((category) => this.generateCategoryField(category));
        }
    }

    generateCategoryField(category) {
        let $editor = (
            eotwJSXFactory('div', {class: "admin-categories-editor__category", 'data-id': category.id}, [
                eotwJSXFactory('input', {type: "text", class: "admin-form__input", value: category.name}),
                eotwJSXFactory('button', {class: "admin-btn admin-btn--icon js-remove"}, [
                    eotwJSXFactory('span', {class: "admin-btn__icon"}).html("<svg><use xmlns:xlink='http://www.w3.org/1999/xlink' xlink:href='" + window.CONFIG.adminBuildUrl + "base/icons.svg#delete'></use></svg>")
                ])
            ])
        );

        $editor.on("click", ".js-remove", () => {
            this.editors = this.editors.filter(($el) => $el !== $editor);
            $editor.remove();
            this.emit("change");
            return false;
        });

        this.editors.push($editor);
        this.$element.append($editor);

        this.updateAddItem();

        return $editor;
    }

}

FieldEditor.register_editor('content/admin/category/categories', AdminCategoriesEditor);

export default AdminCategoriesEditor;
